import { render, staticRenderFns } from "./ConsolidationType.vue?vue&type=template&id=8b4c5492&scoped=true"
import script from "./ConsolidationType.vue?vue&type=script&lang=js"
export * from "./ConsolidationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4c5492",
  null
  
)

export default component.exports